import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: goals.BadgeVerification.
export default class BadgeVerification extends Fragment {
  declare [Type]: 'goals/badge-verification';

  // The type of verification method.
  // Supported values for single assertion verification are HostedBadge and SignedBadge
  // (aliases in context are available: hosted and signed).
  // "hosted"
  @attr('string', { defaultValue: '' })
  declare type: string;
}
